import React, { Component } from "react";
import ReactLoading from "react-loading";
import Header from "./components/Header";
import Buy from "./Buy";
import { postRequest } from "../../../utils/httpRequest";
import { validateString, validateTotalAmount, calcfixedPrice } from "./helpers";
import "./index.scss";
import CheckBrokerStatus from "./components/CheckBrokersStatus";
import CreateOfferModal from "./components/CreateofferModal";
import bcloader from "../../../../assets/images/bcloader.gif";
import { error } from "console";
import { t } from "../../../utils/i18n";

class New extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tradeType: props.tradeType,
      step: "selectTrade",
      token: "USDT",
      selectedCurrency: {
        label: props.currentUserAltCurrency,
        value: props.currentUserAltCurrency,
        rateToUsd: props.currentUserAltCurrencyRate,
        overrideRate: null,
        sellRate: null,
        buyRate: null,
      },
      selectedCountry: {
        label: props.currentUserCountry,
        value: props.currentUserCountryCode,
      },
      selectedPaymentMethod: { label: "Bank Transfer", value: "bank-transfer" },
      selectedOnlineWallet: null,
      selectedPaymentMethodGroup: "bank-transfers",
      selectedPaymentMethodId: props.bankTransferPaymentMethodId,
      selectedBankAccount: {},
      margin: 5,
      rangeMin: null,
      rangeMax: null,
      paymentWindow: 8,
      offerTerms: "",
      tradeDetails: "",
      tags: [{ label: "no third parties", value: "no-third-parties" }],
      fixedPrice: 0.0,
      amount: 0.0,
      tradeFees: props.tradeFees,
      isFixedPrice: false,
      requireVerifiedId: false,
      requireMinPastTrades: 0,
      showOnlyTrustedUser: false,
      requireTraderName: false,
      countryLimitationType: "none",
      countryLimitationList: null,
      hasError: false,
      validationMessage: "",
      customOfferLabel: props.currentUserName,
      dutyHours: [],
      availableBalance: parseFloat(props.availableBalance).toFixed(2),
      showModal: false,
      errorModal: false,
      isProfanityDetected: false,
      isForbiddenOfferNameDetected: false,
      isForbiddenOfferLabelDetected: false,
      amountValError: 0,
    };
    this.toggleModal = this.toggleModal.bind(this);
  }

  componentDidMount() {}

  updateState = (key, value) => {
    this.setState({ [key]: value });
  };

  getState = (key) => {
    return this.state[key];
  };

  updatePreviousStep = (e) => {
    e.preventDefault();

    const { step } = this.state;

    switch (step) {
      case "settings":
        this.setState({ step: "pricing" });

      case "pricing":
        this.setState({ step: "selectTrade" });
    }
  };

  scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  updateNextStep = (e, step) => {
    const { amount, availableBalance, tradeType, tradeFees } = this.state;
    e.preventDefault();
    let isError = false;

    if (step === "pricing") {
      if (!this.state.selectedPaymentMethod) {
        this.updateState("validationMessage", t("p2p.new.payment_method_required"));
        this.updateState("hasError", true);
        isError = true;
        this.scrollToTop();
      }

      if (
        this.state.selectedPaymentMethod.value === "bank-transfer" &&
        !this.state.selectedBankAccount.label
      ) {
        this.updateState(
          "validationMessage",
          t("p2p.new.select_bank")
        );
        this.updateState("hasError", true);
        isError = true;
        this.scrollToTop();
      }

      if (
        this.state.selectedPaymentMethodGroup === "online-transfers" &&
        this.state.selectedPaymentMethod.value !== "airline-tickets" &&
        !this.state.selectedOnlineWallet
      ) {
        this.updateState(
          "validationMessage",
          t("p2p.new.select_wallet")
        );
        this.updateState("hasError", true);
        isError = true;
        this.scrollToTop();
      }

      if (!this.state.selectedCurrency) {
        this.updateState(
          "validationMessage",
          t("p2p.new.select_currency")
        );
        this.updateState("hasError", true);
        isError = true;
        this.scrollToTop();
      }
    } else if (step === "settings") {
      if (!this.state.rangeMin) {
        this.updateState(
          "validationMessage",
          t("p2p.new.min_limit")
        );
        this.updateState("hasError", true);
        isError = true;
        this.scrollToTop();
      } else if (!this.state.rangeMax) {
        this.updateState(
          "validationMessage",
          t("p2p.new.max_limit")
        );
        this.updateState("hasError", true);
        isError = true;
        this.scrollToTop();
      } else if (Number(this.state.rangeMin) > Number(this.state.rangeMax)) {
        this.updateState(
          "validationMessage",
          t("p2p.new.max_gt_min")
        );
        this.updateState("hasError", true);
        isError = true;
        this.scrollToTop();
      } else if (this.state.amountValError === 1) {
        this.updateState(
          "validationMessage",
          t("p2p.new.max_gt_total", { currency: this.state.selectedCurrency.value })
        );
        this.updateState("hasError", true);
        isError = true;
        this.scrollToTop();
      }
    }

    if (!isError) {
      this.setState({ step, hasError: false, validationMessage: "" });
    }
  };

  submitParams = () => {
    let tempFixedPrice = calcfixedPrice(
      this.state.tradeType,
      this.state.selectedCurrency
    );

    return {
      offer_type_field: this.state.tradeType,
      margin: this.state.margin,
      amount: parseFloat(parseFloat(this.state.amount).toFixed(2)),
      range_min: parseFloat(this.state.rangeMin),
      range_max: parseFloat(this.state.rangeMax),
      payment_window: this.state.paymentWindow,
      offer_terms: this.state.offerTerms,
      trade_details:
        this.state.selectedOnlineWallet?.details || this.state.tradeDetails,
      tags: JSON.stringify(this.state.tags),
      flow_type: this.state?.flowType || this.state.tradeType,
      offer_cap_status: true,
      offer_cap_amount: parseInt(this.state.rangeMax),
      fixed_price: tempFixedPrice,
      bank_accounts: JSON.stringify(this.state.selectedBankAccount.value),
      is_fixed_price: this.state.isFixedPrice,
      predefined_amount: parseInt(this.state.rangeMin),
      payment_method_label: this.state.selectedPaymentMethod.label,
      bank_reference_type: "account",
      bank_reference_message: this.state.selectedBankAccount.value,
      show_only_trusted_user: this.state.showOnlyTrustedUser,
      country_limitation_type: this.state.countryLimitationType,
      require_min_past_trades: this.state.requireMinPastTrades,
      require_verified_email: false,
      require_verified_phone: false,
      require_verified_id: this.state.requireVerifiedId,
      active: true,
      is_featured: false,
      duty_hours: this.state.dutyHours,
      payment_method_id: this.state.selectedPaymentMethodId,
      country_code: this.state.selectedCountry.value,
      crypto_currency_code: this.state.token,
      fiat_currency_code: this.state.selectedCurrency.value,
      user_country_code: this.state.selectedCountry.value,
      country_limitation_list: JSON.stringify(
        this.state.countryLimitationList || ""
      ),
      trade_type: this.state.tradeType,
      custom_offer_label: this.state.customOfferLabel,
    };
  };

  onSubmit = (e) => {
    e.preventDefault();

    if (this.state.tags === "" || this.state.tags?.length === 0) {
      this.updateState("validationMessage", t("p2p.new.select_tag"));
      this.updateState("hasError", true);
      this.scrollToTop();
      return;
    }

    if (this.state.customOfferLabel.length > 25) {
      this.updateState(
        "validationMessage",
        t("p2p.new.label_too_long")
      );
      this.updateState("hasError", true);
      this.scrollToTop();
      return;
    }

    if (
      !this.state.customOfferLabel ||
      this.state.customOfferLabel.trim().length === 0 ||
      !this.state.offerTerms ||
      this.state.offerTerms.trim().length === 0
    ) {
      this.updateState(
        "validationMessage",
        t("p2p.new.fill_required")
      );
      this.updateState("hasError", true);
      this.scrollToTop();
      return;
    }

    const validateCustomOfferLabel = validateString(
      this.state.customOfferLabel
    );

    if (validateCustomOfferLabel) {
      this.updateState(
        "validationMessage",
        t("p2p.new.label_invalid")
      );
      this.updateState("hasError", true);
      this.scrollToTop();
      return;
    }

    const validateOfferTerms = validateString(this.state.offerTerms);

    if (validateOfferTerms) {
      this.updateState(
        "validationMessage",
        t("p2p.new.terms_invalid")
      );
      this.updateState("hasError", true);
      this.scrollToTop();
      return;
    }

    this.setState({
      isSubmitting: true,
      hasError: false,
      validationMessage: "",
    });

    postRequest("/p2p_trades/offers", this.submitParams())
      .then((response) => {
        this.setState({
          isSubmitting: false,
          showModal: true,
        });
        const createOfferModal = document.querySelector(
          "#createoffer-status-cont"
        );
        if (createOfferModal) {
          createOfferModal.style.display = "flex";
        }
      })
      .catch((error) => {
        this.setState({
          isSubmitting: false,
          errorModal: true,
        });
        const createOfferModals = document.querySelector(
          "#createoffer-status-cont"
        );
        if (createOfferModals) {
          createOfferModals.style.display = "flex";
        }
        const errorDetails = error?.data?.errors?.[0];
        if (errorDetails) {
          const { attribute, error } = errorDetails;
          this.updateState(
            "validationMessage",
            `${attribute.replaceAll(/_/g, " ")} ${error}`
          );
          this.updateState("hasError", true);
          this.scrollToTop();
        }
      });
  };

  toggleModal = () => {
    this.setState((prevState) => ({
      showModal: !prevState.showModal,
    }));
  };

  closeModal = () => {
    const createOfferModal = document.querySelector("#createoffer-status-cont");
    if (createOfferModal) {
      createOfferModal.style.display = "none";
    }
  };

  handleProfanityDetection = (isProfanityDetected) => {
    this.setState({ isProfanityDetected });
  };

  handleForbiddenOfferNameDetection = (isForbiddenOfferNameDetected) => {
    this.setState({ isForbiddenOfferNameDetected });
  };

  handleForbiddenOfferLabelDetection = (isForbiddenOfferLabelDetected) => {
    this.setState({ isForbiddenOfferLabelDetected });
  };

  render() {
    const {
      tradeType,
      token,
      step,
      isSubmitting,
      showModal,
      errorModal,
      isProfanityDetected,
      isForbiddenOfferNameDetected,
      isForbiddenOfferLabelDetected,
    } = this.state;

    return (
      <div className="p2p-trades _create-offer mobile-p2p-trades createoffer-p2p-trades">
        <CheckBrokerStatus />
        <div className="create-offer-title">
          <p className="create-trade-page-title">
            <i class="fas fa-plus-circle"></i>
            {t("p2p.new.title", {
              type:
                this.state.tradeType === "sell"
                  ? t("p2p.common.sell")
                  : t("p2p.common.buy"),
            })}
          </p>
        </div>

        <div>
          <div>
            <Header tradeType={tradeType} token={token} step={step} />
          </div>

          <div
            className={`step-info-cont ${
              tradeType === "sell" ? "step-info-cont-sell" : ""
            }`}
          >
            <div className="">
              {step === "pricing" ? (
                <div>
                  <p className="step-info-title">
                    <b>
                      <i className="fa fa-question-circle"></i> {t("p2p.new.step_label", { number: 2 })}
                    </b>
                    <span
                      dangerouslySetInnerHTML={{ __html: t("p2p.new.step2_html") }}
                    />
                  </p>
                </div>
              ) : step === "settings" ? (
                <div>
                  <p className="step-info-title">
                    <b>
                      <i className="fa fa-question-circle"></i> {t("p2p.new.step_label", { number: 3 })}
                    </b>
                    <span>{t("p2p.new.step3")}</span>
                  </p>
                </div>
              ) : (
                <div>
                  <p className="step-info-title">
                    <b>
                      <i className="fa fa-question-circle"></i> {t("p2p.new.step_label", { number: 1 })}
                    </b>
                    <span>{t("p2p.new.step1")}</span>
                  </p>
                </div>
              )}
            </div>
            {this.state.hasError && (
              <div className="createoffer-error-alert">
                {this.state.validationMessage}
              </div>
            )}
            <div className="create-offers">
              <Buy
                getData={this.getState}
                updateParent={this.updateState}
                step={step}
                token={token}
                handleForbiddenOfferNameDetection={
                  this.handleForbiddenOfferNameDetection
                }
                handleForbiddenOfferLabelDetection={
                  this.handleForbiddenOfferLabelDetection
                }
                handleProfanityDetection={this.handleProfanityDetection}
              />
            </div>
          </div>

          <div className="createoffer-buttons-parentsection">
            {step === "selectTrade" && (
              <div className="createoffer-buttons-section">
                <button
                  type="button"
                  className={`createoffer-next-submit-button ${
                    tradeType === "sell" ? "createoffer-sell-btn" : ""
                  }`}
                  onClick={(e) => this.updateNextStep(e, "pricing")}
                >
                  <span>{t("p2p.new.next")}</span> <i class="fa-solid fa-arrow-right"></i>
                </button>
              </div>
            )}
            {step === "pricing" && (
              <div className="createoffer-buttons-section">
                <button
                  type="button"
                  className="createoffer-prev-cancel-button"
                  onClick={(e) => this.updateNextStep(e, "selectTrade")}
                >
                  <i class="fa-solid fa-arrow-left"></i>
                  <span>{t("p2p.new.previous")}</span>
                </button>
                <button
                  type="button"
                  className={`createoffer-next-submit-button ${
                    tradeType === "sell" ? "createoffer-sell-btn" : ""
                  }`}
                  onClick={(e) => this.updateNextStep(e, "settings")}
                >
                  <span>{t("p2p.new.next")}</span> <i class="fa-solid fa-arrow-right"></i>
                </button>
              </div>
            )}

            {step === "settings" && (
              <div className="createoffer-buttons-section">
                <button
                  type="button"
                  className="createoffer-prev-cancel-button"
                  onClick={(e) => this.updateNextStep(e, "pricing")}
                >
                  {t("p2p.new.previous")}
                </button>
                <button
                  type="button"
                  className="createoffer-next-submit-button"
                  disabled={
                    isSubmitting ||
                    isProfanityDetected ||
                    isForbiddenOfferNameDetected ||
                    isForbiddenOfferLabelDetected
                  }
                  onClick={this.onSubmit}
                >
                  {isSubmitting ? t("p2p.new.submitting") : t("p2p.common.submit")}
                </button>
                <br />
              </div>
            )}
          </div>

          {/* Modal section */}
          <div>
            {isSubmitting && (
              <div id="createoffer-status-cont">
                <div className="createoffer-status-section">
                  <button
                    type="button"
                    className="close"
                    onClick={() => this.closeModal()}
                    aria-label={t("p2p.common.close")}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <p className="createoffer-loader">
                    <img src={bcloader} alt={t("p2p.common.loader_alt")} />
                    {t("p2p.new.creating")}
                  </p>
                </div>
              </div>
            )}

            {showModal && (
              <div id="createoffer-status-cont">
                <div className="createoffer-status-section">
                  <CreateOfferModal
                    statusMessage={t("p2p.new.created")}
                    successStatus={true}
                  />
                </div>
              </div>
            )}

            {errorModal && (
              <div id="createoffer-status-cont">
                <div className="createoffer-status-section">
                  <button
                    type="button"
                    className="close"
                    onClick={() => this.closeModal()}
                    aria-label={t("p2p.common.close")}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <CreateOfferModal
                    statusMessage={t("p2p.new.failed")}
                    successStatus={false}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default New;
